/* unplugin-vue-components disabled */import { render } from "./DigitSymbolReactionReview.vue?vue&type=template&id=7f7c1852&scoped=true"
import script from "./DigitSymbolReactionReview.vue?vue&type=script&lang=js"
export * from "./DigitSymbolReactionReview.vue?vue&type=script&lang=js"

import "./DigitSymbolReactionReview.vue?vue&type=style&index=0&id=7f7c1852&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f7c1852"]])

export default __exports__